import styled from "styled-components"
import Img from "gatsby-image"

export const StyledHerroImage = styled(Img)`
  width: 100%;
  height: 100%;
`
